var SensitiveData;
(function (SensitiveData) {
    SensitiveData["HIDDEN"] = "hidden";
    SensitiveData["NONE"] = "none";
    SensitiveData["PARTIALLY_HIDDEN"] = "partially-hidden";
})(SensitiveData || (SensitiveData = {}));
export { SensitiveData, };
//# sourceMappingURL=sensitive-data.js.map